export default __webpack_public_path__ + "13eeb4f2f95a2a31dc9dd6a05689eac9.png";